import React from 'react';
import PropTypes from 'prop-types';
import 'styles/admin/LibraryManagement.styl';
import LibraryCreateDialog from 'components/pure/library/LibraryCreateDialog';
import LibraryTable from 'components/pure/admin/LibraryTable';

export default class LibraryManagement extends React.PureComponent {
  getLibraries() {
    return this.props.LibraryStore.getIn(['sources', 'libraries']) || [];
  }

  getDialogProps() {
    return {
      createForm: this.props.LibraryCreateFormStore,
      formState: this.props.LibraryStore.get('formState'),
      shareAccessible: this.props.LibraryStore.get('shareAccessible'),
      adminManage: true,
      sources: this.props.LibraryStore.get('sources'),
      user: this.props.AuthStore.user,
    };
  }

  render() {
    return (
      <div className="library-management">
        <h1>Library Management</h1>
        <div className="library-table">
          <div className="table-container">
            <LibraryTable libraries={this.getLibraries()} />
          </div>
        </div>
        <div>
          <LibraryCreateDialog {...this.getDialogProps()} />
        </div>
      </div>
    );
  }
}

LibraryManagement.propTypes = {
  LibraryStore: PropTypes.object.isRequired,
};

LibraryManagement.defaultProps = {
  LibraryStore: {},
};

LibraryManagement.displayName = 'LibraryManagement';
